import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { DatagridService, PagedResultGeneric, PagedSearch } from 'src/app/shared';
import { LazySelectableTableComponent } from 'src/app/shared/primeng/abstract-classes/lazy-selectable-table.component';
import { FinancialApiService } from '../../shared/financial-api.service';
import { TransactionSearchV2Dto } from '../../shared/transaction/dto/transaction-searchv2.dto';
import { PostedTransactionDto } from '../../shared/transaction/dto/posted-transaction.dto';
import { NavigationService } from 'src/app/shared/navigation/navigation.service';
import { FinancialServiceService } from '../../shared/financial.service';

@Component({
  selector: 'wl-detailed-transactions-grid',
  templateUrl: './detailed-transactions-grid.component.html',
  styleUrls: ['./detailed-transactions-grid.component.less'],
    standalone: false
})
export class DetailedTransactionsGridComponent extends LazySelectableTableComponent<TransactionSearchV2Dto, PostedTransactionDto> {
  @Input() searchDto: TransactionSearchV2Dto;
  exporting: boolean = false;
  constructor(
    datagridService: DatagridService,
    public _financialService: FinancialServiceService,
    private _navigationService: NavigationService
  ) {
    super('', datagridService);
    this.searchParams = this.searchDto ?? ({ PageNumber: 1, PageSize: 20 } as TransactionSearchV2Dto);
  }

  fetchResults(): Promise<PagedResultGeneric<PostedTransactionDto>> {
    this.setSearchParams();
    return this._financialService.getTransactions(this.searchParams);
  }

  pageSizeChanged() {
    this.searchParams.PageNumber = 1;
    this.search();
  }

  exportResults() {
    this.exporting = true;
    this._financialService
      .exportTransactions(this.searchParams)
      .then((csvUrl) => {
        this._navigationService.popupSafeNavigate(csvUrl);
      })
      .finally(() => {
        this.exporting = false;
      });
  }

  private setSearchParams() {
    this.searchParams.Account = this.searchDto.Account;
    this.searchParams.AccountingPackageID = this.searchDto.AccountingPackageID;
    this.searchParams.ApplyDateEnd = this.searchDto.ApplyDateEnd;
    this.searchParams.ApplyDateStart = this.searchDto.ApplyDateStart;
    this.searchParams.BatchPosting = this.searchDto.BatchPosting;
    this.searchParams.DatePostedEnd = this.searchDto.DatePostedEnd;
    this.searchParams.DatePostedStart = this.searchDto.DatePostedStart;
    this.searchParams.TransactionType = this.searchDto.TransactionType;
  }
}
